<button class="h-[32px] w-[32px] flex items-center justify-center relative" (click)="toggleDropdown()">
  <lib-notification-bell-icon />
  <lib-notification-counter [counter]="unreadCount" />
</button>

<div *ngIf="isDropdownVisible" class="w-[452px] absolute right-0 mt-[8px] bg-white rounded-[8px] z-[10] mr-[12px]">
  <lib-notification-dropdown 
    [notifications]="notifications" 
    [(isUpdating)]="isUpdating" 
    (unreadChanged)="setUnreadCount($event)"
    (navigated)="isDropdownVisible = false">
</lib-notification-dropdown>
</div>
